import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "profile-pop__card" }
const _hoisted_2 = { class: "profile-pop__profile-box" }
const _hoisted_3 = { class: "profile-pop__profile-name" }
const _hoisted_4 = { class: "profile-pop__subtitle-box" }
const _hoisted_5 = { class: "profile-pop__card-subcontent" }
const _hoisted_6 = { class: "profile-pop__subtitle-box" }
const _hoisted_7 = { class: "profile-pop__card-subcontent" }
const _hoisted_8 = { class: "profile-pop__subtitle-box" }
const _hoisted_9 = { class: "profile-pop__card-subcontent" }
const _hoisted_10 = { class: "profile-pop__subtitle-box" }
const _hoisted_11 = { class: "profile-pop__card-subcontent" }
const _hoisted_12 = { class: "profile-pop__subtitle-box" }
const _hoisted_13 = { class: "profile-pop__card-subcontent" }
const _hoisted_14 = { class: "profile-pop__subtitle-box" }
const _hoisted_15 = { class: "profile-pop__subtitle-box" }
const _hoisted_16 = { class: "profile-pop__card-subcontent" }
const _hoisted_17 = { class: "profile-pop__subtitle-box" }
const _hoisted_18 = { class: "profile-pop__card-subcontent" }
const _hoisted_19 = {
  key: 1,
  class: "profile-pop__subtitle-box"
}
const _hoisted_20 = { class: "profile-pop__card-subcontent" }
const _hoisted_21 = {
  key: 0,
  class: "profile-pop__card-subcontent-money"
}
const _hoisted_22 = {
  key: 1,
  class: "profile-pop__card-money"
}
const _hoisted_23 = {
  key: 0,
  class: "profile-pop__card"
}
const _hoisted_24 = { class: "profile-pop__title-box" }
const _hoisted_25 = { class: "flex items-center gap-4" }
const _hoisted_26 = { class: "profile-pop__star_total" }
const _hoisted_27 = { class: "profile-pop__star_total_text" }
const _hoisted_28 = { class: "profile-pop__star_icon" }
const _hoisted_29 = { class: "profile-pop__star-box" }
const _hoisted_30 = { class: "profile-pop__star-topbar" }
const _hoisted_31 = { class: "profile-pop__star-rating" }
const _hoisted_32 = { class: "profile-pop__star-date" }
const _hoisted_33 = { class: "profile-pop__star-comment" }
const _hoisted_34 = { class: "profile-pop__star-image-container" }
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "profile-pop__card" }
const _hoisted_37 = { class: "profile-pop__job-subtitle-date" }
const _hoisted_38 = { class: "profile-pop__job-subcontent" }
const _hoisted_39 = { class: "profile-pop__subtitle-box" }
const _hoisted_40 = { class: "profile-pop__job-position" }
const _hoisted_41 = { class: "profile-pop__job-position-subcontent" }
const _hoisted_42 = { class: "profile-pop__job-salary" }
const _hoisted_43 = { class: "profile-pop__job-subcontent-salary" }
const _hoisted_44 = { class: "profile-pop__subtitle-box-end" }
const _hoisted_45 = ["innerHTML"]

import { ref } from 'vue';
import moment from 'moment';
import { getMemberProfile } from '@/api/member';
// import { getReviews } from '@/api/review';

// import { getUrlFile } from '@/api/file';

import StarRate from '@/components/StarRate.vue';
import DefaultProfileImage from '@/components/DefaultProfileImage.vue';
import PersonalColor from '@/components/PersonalColor.vue';
import BaseButton from '@/components/BaseButton.vue';
import BasePopup from '@/components/BasePopup.vue';
import StarPost from '@/components/StarPost.vue';
import { roleStore } from '@/stores/role';

import { $t } from '@/plugins/translation';
import { onMounted } from 'vue';
import { onBeforeUnmount } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfilePop',
  props: {
  profileForm: {
    type: Object,
    default: () => ({}),
  },
},
  setup(__props) {

const moduleRole = roleStore();

const props = __props;

const isStarPopup = ref(false);
const startPost = ref(null);

const reviews = ref([]);

const profileInfo = ref({});

const handleGetProfile = async () => {
  try {
    const res = await getMemberProfile({
      memberId: props.profileForm?.memberId,
    });
    profileInfo.value = res.data;
   } catch (error) {
    console.error(error);
  }
};
// const handleGetReviews = async () => {
//   try {
//     const res = await getReviews({
//       memberIdx: profileInfo.value.memberIdx,
//     });

//     reviews.value = await Promise.all(
//       res.data.data.map(async (review) => {
//         if (review.medias?.length) {
//           const medias = await Promise.all(
//             review.medias?.map(async (fileIdx) => await handleGetUrlFile(fileIdx)),
//           );

//           return {
//             ...review,
//             medias,
//           };
//         }
//         return review;
//       }),
//     );
//   } catch (error) {
//     console.error(error);
//   }
// };
// const handleGetUrlFile = async (fileIdx) => {
//   try {
//     const response = await getUrlFile({
//       fileIdx,
//     });
//     return response.data.url;
//   } catch (e) {
//     console.error(e);
//   }
// };
handleGetProfile();

// check device
const isMobile = ref(true);

const checkIsMobile = () => {
  isMobile.value = window.innerWidth < 767;
}

onMounted(() => {
  checkIsMobile();
  window.addEventListener('resize', checkIsMobile);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', checkIsMobile);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["profile-pop last:mb-2 relative", isMobile.value ? 'mo':''])
    }, [
      _createElementVNode("i", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeProfile'))),
        class: "c-icon c-icon--close absolute right-0 top-5 cursor-pointer"
      }, _cache[4] || (_cache[4] = [
        _createElementVNode("span", { class: "s-hide" }, "close", -1)
      ])),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(DefaultProfileImage, {
            profileForm: __props.profileForm,
            ableShowProfile: false,
            size: 140
          }, null, 8, ["profileForm"])
        ]),
        _createElementVNode("div", _hoisted_3, _toDisplayString(profileInfo.value.nickname), 1),
        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "profile-pop__title-box" }, null, -1)),
        (_unref(moduleRole).isAdmin)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_4, [
                _cache[5] || (_cache[5] = _createElementVNode("span", { class: "profile-pop__card-subtitle" }, "이메일", -1)),
                _createElementVNode("div", _hoisted_5, _toDisplayString(profileInfo.value.email), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[6] || (_cache[6] = _createElementVNode("span", { class: "profile-pop__card-subtitle" }, "이름", -1)),
                _createElementVNode("span", _hoisted_7, _toDisplayString(profileInfo.value.name), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[7] || (_cache[7] = _createElementVNode("span", { class: "profile-pop__card-subtitle" }, "휴대폰번호", -1)),
                _createElementVNode("span", _hoisted_9, _toDisplayString(profileInfo.value.phone), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "profile-pop__card-subtitle" }, "생년월일", -1)),
                _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(moment)(profileInfo.value.birth).format('YYYY.MM.DD')), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "profile-pop__card-subtitle" }, "성별", -1)),
                _createElementVNode("span", _hoisted_13, _toDisplayString(profileInfo.value.gender == 'M' ? _unref($t)('views.profile', 'male') : _unref($t)('views.profile', 'female')), 1)
              ])
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_14, [
          _cache[10] || (_cache[10] = _createElementVNode("span", { class: "profile-pop__card-subtitle" }, "퍼스널컬러", -1)),
          _createElementVNode("span", {
            class: _normalizeClass(["profile-pop__card-subcontent gap-2", `${isMobile.value ? 'grid grid-cols-4':'flex'}`])
          }, [
            _createVNode(PersonalColor, {
              "select-color": profileInfo.value.colorCode
            }, null, 8, ["select-color"])
          ], 2)
        ]),
        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "profile-pop__title-box" }, [
          _createElementVNode("span", { class: "profile-pop__card-title" }, "업무")
        ], -1)),
        _createElementVNode("div", _hoisted_15, [
          _cache[11] || (_cache[11] = _createElementVNode("span", { class: "profile-pop__card-subtitle" }, "직무", -1)),
          _createElementVNode("span", _hoisted_16, _toDisplayString(profileInfo.value.job), 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _cache[12] || (_cache[12] = _createElementVNode("span", { class: "profile-pop__card-subtitle" }, "업무성격", -1)),
          _createElementVNode("span", _hoisted_18, _toDisplayString(__props.profileForm.isFree == null ? '프리랜서' : '정규직'), 1)
        ]),
        (_unref(moduleRole).isAdmin)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _cache[13] || (_cache[13] = _createElementVNode("span", { class: "profile-pop__card-subtitle" }, "희망 일당", -1)),
              _createElementVNode("span", _hoisted_20, [
                _createTextVNode(_toDisplayString(profileInfo.value.hopePrice) + " ", 1),
                (profileInfo.value.isFree == null)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, "만원/8시간"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_22, "만원/8시간"))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      false
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _cache[17] || (_cache[17] = _createElementVNode("span", { class: "profile-pop__card-title-starRate" }, "별점", -1)),
                _createVNode(BaseButton, {
                  color: "outline",
                  size: "small",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (isStarPopup.value = true))
                }, {
                  default: _withCtx(() => _cache[16] || (_cache[16] = [
                    _createTextVNode(" 별점 주기 ")
                  ])),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, _toDisplayString(profileInfo.value?.rating?.toFixed(1)), 1),
                _cache[18] || (_cache[18] = _createTextVNode(" /5 ")),
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(StarRate, {
                    id: profileInfo.value?.rating?.toFixed(1)
                  }, null, 8, ["id"])
                ])
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reviews.value, (review) => {
              return (_openBlock(), _createElementBlock("div", {
                key: review.reviewMemberIdx,
                class: "profile-pop__star-container"
              }, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(StarRate, {
                        id: review.rating
                      }, null, 8, ["id"])
                    ]),
                    _createElementVNode("div", _hoisted_32, _toDisplayString(_unref($t)('common', 'formatDt')(review.createdAt, 'YYYYMMDDHHmmss', 'YYYY.MM.DD')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, _toDisplayString(review.content), 1),
                _createElementVNode("div", _hoisted_34, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(review.medias, (src, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      alt: "image"
                    }, [
                      _createElementVNode("img", {
                        class: "profile-pop__star-image-box",
                        src: src
                      }, null, 8, _hoisted_35)
                    ]))
                  }), 128))
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_36, [
        _cache[22] || (_cache[22] = _createElementVNode("span", { class: "profile-pop__card-title" }, "경력", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profileInfo.value.career, (career, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "profile-pop__job-box",
            key: index
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["profile-pop__subtitle-box", `${isMobile.value ? 'justify-between' : ''}`])
            }, [
              _createElementVNode("span", _hoisted_37, _toDisplayString(career.startDt + ' ~ ' + career.endDt), 1),
              _createElementVNode("span", _hoisted_38, _toDisplayString(career.company), 1)
            ], 2),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _cache[19] || (_cache[19] = _createElementVNode("span", { class: "profile-pop__job-position-subtitle" }, "직급/직무", -1)),
                _createElementVNode("span", _hoisted_41, _toDisplayString(career.level), 1)
              ]),
              _createElementVNode("div", _hoisted_42, [
                _cache[20] || (_cache[20] = _createElementVNode("span", { class: "profile-pop__job-subtitle" }, "연봉", -1)),
                _createElementVNode("span", _hoisted_43, _toDisplayString(career.salary), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _cache[21] || (_cache[21] = _createElementVNode("span", { class: "profile-pop__job-subtitle" }, "업무", -1)),
              _createElementVNode("span", {
                class: "profile-pop__job-workcontent",
                innerHTML: career.description.replace(/\n/g, '<br />')
              }, null, 8, _hoisted_45)
            ])
          ]))
        }), 128))
      ])
    ], 2),
    _createVNode(BasePopup, {
      modelValue: isStarPopup.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isStarPopup).value = $event)),
      title: "별점 주기",
      confirmText: "별점 주기",
      onConfirm: _cache[3] || (_cache[3] = 
      async () => {
        await startPost.value.handleCreateReview();
        _ctx.handleGetReviews();
      }
    )
    }, {
      default: _withCtx(() => [
        _createVNode(StarPost, {
          memberIdx: __props.profileForm.memberIdx,
          ref_key: "startPost",
          ref: startPost
        }, null, 8, ["memberIdx"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})